import React from 'react';
import { GlobalSideNavigationSidebars } from './GlobalSideNavigationSidebars.tsx';

export function NavPlatformSidebar(): React.JSX.Element {
	/*
		1. Add UFOSegment
		2. Determine which sidebar to show
		  a. If NOT content sidebar,
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
		  b. Otherwise,
		    1. Get items-config (default config), using custom components


	*/
	/*
		Use same sidebar-selector logic as in navigation-apps/sidebar-nav4/sidebar-selector/src/ui/entrypoint/index.tsx
	*/

	return <GlobalSideNavigationSidebars />;
}
